// extracted by mini-css-extract-plugin
module.exports = {"container":"custom_container__3nDHs","wrapper":"custom_wrapper__B8JXM","content":"custom_content__2Uirw","heading":"custom_heading__3d0hb","Text":"custom_Text__EAYgN"};